import styled from 'styled-components';
import { Modal } from 'reactstrap';
import { colors } from 'View/Theme';
import { asRem } from 'utils';

export const StyledModal = styled(Modal)`
  .audio-player-modal {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    margin: auto;
  }

  .modal-content {
    display: flex;
    align-self: center;
    border: ${asRem(1)} solid ${colors.sleep.blue.c900};
    margin: auto;
    background-color: ${colors.sleep.blue.c900};
  }
`;

export const ModalBody = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10%;
  position: relative;

  .close_icon {
    width: ${asRem(50)};
    height: ${asRem(50)};
    position: absolute;
    top: ${asRem(8)};
    right: ${asRem(4)};
  }

  .close-button {
    text-decoration: none;
    position: absolute;
    z-index: 1;
    top: ${asRem(4.8)};
    right: ${asRem(12.8)};
    background-color: transparent;
    color: ${colors.white.c500};
    border: none;
    font-size: ${asRem(40)};
    width: ${asRem(40)};

    &:hover,
    &:focus,
    &:active {
      color: ${colors.grey.c500} !important;
      background-color: transparent !important;
    }
  }

  .modal-image {
    width: 100%;
    aspect-ratio: 750/1000;
  }

  .audio-player {
    background-color: ${colors.sleep.blue.c900};
    border-radius: ${asRem(8)};
    border: ${asRem(1)} solid ${colors.sleep.blue.c900};
    color: ${colors.white.c500};
  }
`;
